<template>
  <b-row class="mb-3">
    <!-- Non-Allocated -->
    <b-col cols="12" md="6" lg="3" class="mb-3">
      <div class="stat-card stat-card--blue">
        <div class="stat-card__header">
          <span class="stat-card__icon">
            <i class="fas fa-wallet" />
          </span>
          <span class="stat-card__title">Non-Allocated</span>
        </div>
        <div class="stat-card__body">
          <div class="stat-card__row">
            <span class="stat-card__label">CAD</span>
            <span class="stat-card__value">
              <!-- {{ twoDecimals(valueCadByFx(totalNonAllocatedUsd)) | currency }} -->
              <span v-b-tooltip.hover :title="String(totalNonAllocatedCad)">{{ totalNonAllocatedCad | currency }}</span>
            </span>
          </div>
          <div class="stat-card__row">
            <span class="stat-card__label">USD</span>
            <span class="stat-card__value">
              <!-- {{ twoDecimals(totalNonAllocatedUsd) | currency }} -->
              <span v-b-tooltip.hover :title="String(totalNonAllocatedUsd)">{{ totalNonAllocatedUsd | currency }}</span>
            </span>
          </div>
        </div>
      </div>
    </b-col>

    <!-- Total Contract -->
    <b-col cols="12" md="6" lg="3" class="mb-3">
      <div class="stat-card stat-card--green">
        <div class="stat-card__header">
          <span class="stat-card__icon">
            <i class="fas fa-file-contract" />
          </span>
          <span class="stat-card__title">Total Contract</span>
        </div>
        <div class="stat-card__body">
          <div class="stat-card__row">
            <span class="stat-card__label">CAD</span>
            <span class="stat-card__value">
              <!-- {{ twoDecimals(valueCadByFx(totalBalanceUsd)) | currency }} -->
              <span v-b-tooltip.hover :title="String(totalBalanceCad)">{{ totalBalanceCad | currency }}</span>
            </span>
          </div>
          <div class="stat-card__row">
            <span class="stat-card__label">USD</span>
            <span class="stat-card__value">
              <!-- {{ twoDecimals(totalBalanceUsd) | currency }} -->
              <span v-b-tooltip.hover :title="String(totalBalanceUsd)">{{ totalBalanceUsd | currency }}</span>
            </span>
          </div>
        </div>
      </div>
    </b-col>

    <!-- Inventory Value -->
    <b-col cols="12" md="6" lg="3" class="mb-3">
      <div class="stat-card stat-card--purple">
        <div class="stat-card__header">
          <span class="stat-card__icon">
            <i class="fas fa-car" />
          </span>
          <span class="stat-card__title">Inventory Value</span>
        </div>
        <div class="stat-card__body">
          <div class="stat-card__row">
            <span class="stat-card__label">CAD</span>
            <div class="stat-card__row-right">
              <span class="stat-card__value">
                <!-- {{ twoDecimals(totalInventoryValueCad) | currency }} -->
                <span v-b-tooltip.hover :title="String(totalInventoryValueCad)">{{ totalInventoryValueCad | currency }}</span>
              </span>
              <button
                class="stat-card__dl-btn"
                title="Download CAD XLS"
                @click="$emit('download-currency', 'cad')"
              >
                <i class="far fa-file-excel" />
                <span>XLS</span>
              </button>
            </div>
          </div>
          <div class="stat-card__row">
            <span class="stat-card__label">USD</span>
            <div class="stat-card__row-right">
              <span class="stat-card__value">
                <!-- {{ twoDecimals(totalInventoryValueUsd) | currency }} -->
                <span v-b-tooltip.hover :title="String(totalInventoryValueUsd)">{{ totalInventoryValueUsd | currency }}</span>
              </span>
              <button
                class="stat-card__dl-btn"
                title="Download USD XLS"
                @click="$emit('download-currency', 'usd')"
              >
                <i class="far fa-file-excel" />
                <span>XLS</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-col>

    <!-- Average FX -->
    <b-col cols="12" md="6" lg="3" class="mb-3">
      <div class="stat-card stat-card--orange">
        <div class="stat-card__header">
          <span class="stat-card__icon">
            <i class="fas fa-exchange-alt" />
          </span>
          <span class="stat-card__title">Average FX</span>
        </div>
        <div class="stat-card__body">
          <div class="stat-card__row">
            <span class="stat-card__label">Contract</span>
            <span class="stat-card__value">
              <!-- {{ twoDecimals(averageContractFx) }} -->
              {{ twoDecimals(averageContractFx) }}
            </span>
          </div>
          <div class="stat-card__row">
            <span class="stat-card__label">Inventory</span>
            <span class="stat-card__value">
              <!-- {{ twoDecimals(averageInventoryFx) }} -->
              {{ twoDecimals(averageInventoryFx) }}
            </span>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ExchangeContractTotals",
  computed: {
    ...mapState({
      totalNonAllocatedCad: (state) =>
        state.superAdminStore.exchangeContract.totalNonAllocatedCad,
      totalNonAllocatedUsd: (state) =>
        state.superAdminStore.exchangeContract.totalNonAllocatedUsd,
      totalBalanceCad: (state) =>
        state.superAdminStore.exchangeContract.totalBalanceCad,
      totalBalanceUsd: (state) =>
        state.superAdminStore.exchangeContract.totalBalanceUsd,
      totalInventoryValueUsd: (state) =>
        state.superAdminStore.exchangeContract.totalInventoryValueUsd,
      totalInventoryValueCad: (state) =>
        state.superAdminStore.exchangeContract.totalInventoryValueCad,
      averageContractFx: (state) =>
        state.superAdminStore.exchangeContract.averageContractFx,
      averageInventoryFx: (state) =>
        state.superAdminStore.exchangeContract.averageInventoryFx,
    }),
  },
  methods: {
    twoDecimals(value) {
      /* value with 2 decimals */
      const fx = value.toString();
      const fxArray = fx.split(".");
      const fxArrayLength = fxArray.length;
      if (fxArrayLength > 1) {
        const fxArrayLast = fxArray[fxArrayLength - 1];
        if (fxArrayLast.length > 2) {
          return fxArray[0] + "." + fxArrayLast.substring(0, 2);
        }
      }
      return fx;
    },
    valueCadByFx(value) {
      return value * this.averageContractFx;
    },
  },
};
</script>

<style scoped>
.stat-card {
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-left: 4px solid transparent;
  background: #fff;
  padding: 20px 18px;
}

.stat-card--blue  { border-left-color: #3b82f6; }
.stat-card--green { border-left-color: #22c55e; }
.stat-card--purple{ border-left-color: #8b5cf6; }
.stat-card--orange{ border-left-color: #f97316; }

.stat-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.stat-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  font-size: 12px;
  flex-shrink: 0;
}

.stat-card--blue  .stat-card__icon { background: #eff6ff; color: #3b82f6; }
.stat-card--green .stat-card__icon { background: #f0fdf4; color: #22c55e; }
.stat-card--purple .stat-card__icon { background: #f5f3ff; color: #8b5cf6; }
.stat-card--orange .stat-card__icon { background: #fff7ed; color: #f97316; }

.stat-card__title {
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #6b7280;
  line-height: 1.2;
}

.stat-card__body {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.stat-card__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 4px 0;
  border-bottom: 1px solid #f3f4f6;
}

.stat-card__row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.stat-card__label {
  font-size: 11px;
  font-weight: 700;
  color: #b0b8c4;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.stat-card__row-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stat-card__value {
  font-size: 14px;
  font-weight: 800;
  color: #1f2937;
  letter-spacing: -0.3px;
}

.stat-card__dl-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #2dce89;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  padding: 3px 8px;
  white-space: nowrap;
  transition: background 0.15s;
}

.stat-card__dl-btn:hover {
  background: #26b576;
}

.stat-card__dl-btn i {
  color: #fff !important;
}
</style>
